import useSWR, { useSWRConfig } from 'swr';
export const useQuery = (key, promise, opts = {}) => {
    const { fallback } = useSWRConfig();
    const { data, error, isLoading } = useSWR(opts.avoidFetch ? null : key, promise, {
        fallback: {
            [`${key}`]: key && fallback && fallback[key] ? fallback[key] : null
        },
        focusThrottleInterval: 30 * 1000,
        onSuccess: (data) => {
            if (opts === null || opts === void 0 ? void 0 : opts.onSuccess) {
                opts === null || opts === void 0 ? void 0 : opts.onSuccess(data);
            }
        },
        onError: (error) => {
            if (opts === null || opts === void 0 ? void 0 : opts.onError) {
                opts === null || opts === void 0 ? void 0 : opts.onError(error);
            }
        }
    });
    return {
        data,
        error,
        isLoading
    };
};
//# sourceMappingURL=useQuery.js.map